'use client'

import { ILastMessage, useSession } from '@repo/sdk'
import { ChatIcon } from '@repo/ui'
import { ReactNode, useState } from 'react'
import { z } from 'zod'

interface Props {
  ChatDrawer: (isOpen: boolean, onClose: () => void) => ReactNode //todo remove once chatdrawer is implemented in @repo/ui
  children?: ReactNode
  lastMessage: ILastMessage | undefined
}

export const ChatCell = ({ ChatDrawer, children, lastMessage }: Props) => {
  const [open, setOpen] = useState(false)

  const { data } = useSession()

  return (
    <div className={'flex items-center justify-center'}>
      {!children ? (
        <ChatIcon
          currentUserId={
            data?.user?.id ? z.coerce.number().optional().parse(data?.user?.id) : undefined
          }
          handleChatClick={() => setOpen(true)}
          lastMessage={lastMessage}
        />
      ) : (
        <div onClick={() => setOpen(true)}>{children}</div>
      )}
      {ChatDrawer(open, () => setOpen(false))}
    </div>
  )
}
